const suggestions={
    currentEventsTab:0,
};

export default suggestions;